// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"_p-z","selected":"aq-z"};